"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.addL1ToLongtailPartsToMemo = void 0;
const chain_adapters_1 = require("@shapeshiftoss/chain-adapters");
const utils_1 = require("@shapeshiftoss/utils");
const assert_1 = __importDefault(require("assert"));
const bignumber_js_1 = __importDefault(require("bignumber.js"));
const thorchain_utils_1 = require("../../../thorchain-utils");
const addAggregatorAddressToMemo_1 = require("../../../thorchain-utils/memo/addAggregatorAddressToMemo");
const addFinalAssetAddressToMemo_1 = require("../../../thorchain-utils/memo/addFinalAssetAddressToMemo");
const addFinalAssetLimitToMemo_1 = require("../../../thorchain-utils/memo/addFinalAssetLimitToMemo");
const constants_1 = require("../constants");
const constants_2 = require("./constants");
const getShortenedFinalAssetLimit_1 = require("./getShortenedFinalAssetLimit");
const getUniqueAddressSubstring_1 = require("./getUniqueAddressSubstring");
const longTailHelpers_1 = require("./longTailHelpers");
const addL1ToLongtailPartsToMemo = ({ sellAssetChainId, quotedMemo, aggregator, finalAssetAssetId, finalAssetAmountOut, slippageBps, longtailTokens, }) => {
    if (!quotedMemo)
        throw new Error('no memo provided');
    const maxMemoSize = (0, constants_1.getMaxBytesLengthByChainId)(sellAssetChainId);
    // Paranonia - If memo without final asset amount out and aggregator is already too long, we can't do anything
    (0, assert_1.default)(quotedMemo.length <= maxMemoSize, 'memo is too long');
    // THORChain themselves use 2 characters but it might collide at some point in the future (https://gitlab.com/thorchain/thornode/-/blob/develop/x/thorchain/aggregators/dex_mainnet_current.go)
    const shortenedAggregatorAddress = aggregator.slice(aggregator.length - 2, aggregator.length);
    const quotedMemoWithAggregator = (0, addAggregatorAddressToMemo_1.addAggregatorAddressToMemo)({
        memo: quotedMemo,
        aggregatorAddress: shortenedAggregatorAddress,
    });
    const finalAssetContractAddressShortened = (0, getUniqueAddressSubstring_1.getUniqueAddressSubstring)(finalAssetAssetId, longtailTokens);
    const quotedMemoWithAggregatorAndFinalAssetContract = (0, addFinalAssetAddressToMemo_1.addFinalAssetAddressToMemo)({
        memo: quotedMemoWithAggregator,
        finalAssetAddress: finalAssetContractAddressShortened,
    });
    const [prefix, nativeAssetName, address, nativeAssetLimitWithManualSlippage, affiliate, affiliateBps, aggregatorLastTwoChars, finalAssetContract,] = quotedMemoWithAggregatorAndFinalAssetContract.split(constants_2.MEMO_PART_DELIMITER);
    const shortenedNativeAssetName = longTailHelpers_1.shortenedNativeAssetNameByNativeAssetName[nativeAssetName];
    (0, assert_1.default)(shortenedNativeAssetName, 'cannot find shortened native asset name');
    const memoWithoutFinalAssetLimit = [
        prefix,
        shortenedNativeAssetName,
        address,
        nativeAssetLimitWithManualSlippage,
        affiliate,
        affiliateBps,
        aggregatorLastTwoChars,
        finalAssetContract,
    ].join(constants_2.MEMO_PART_DELIMITER);
    // Paranonia - If memo without final asset amount out is already too long, we can't do anything
    (0, assert_1.default)(memoWithoutFinalAssetLimit.length <= maxMemoSize, 'memo is too long');
    const finalAssetLimitWithManualSlippage = (0, utils_1.subtractBasisPointAmount)((0, chain_adapters_1.bn)(finalAssetAmountOut).toFixed(0, bignumber_js_1.default.ROUND_DOWN), slippageBps, bignumber_js_1.default.ROUND_DOWN);
    const shortenedFinalAssetAmount = (0, getShortenedFinalAssetLimit_1.getShortenedFinalAssetLimit)({
        maxMemoSize,
        memoWithoutFinalAssetLimit,
        finalAssetLimitWithManualSlippage,
    });
    const memoWithShortenedFinalAssetAmountOut = (0, addFinalAssetLimitToMemo_1.addFinalAssetLimitToMemo)({
        memo: memoWithoutFinalAssetLimit,
        finalAssetLimit: shortenedFinalAssetAmount,
    });
    (0, assert_1.default)(memoWithShortenedFinalAssetAmountOut.length <= maxMemoSize, 'memo is too long');
    return (0, thorchain_utils_1.assertAndProcessMemo)(memoWithShortenedFinalAssetAmountOut);
};
exports.addL1ToLongtailPartsToMemo = addL1ToLongtailPartsToMemo;
